import type { CursorPagination, CursorPaginationParams } from './base'
import type { Customer } from './customer'

export interface Vehicle {
  driverCarID?: string
  driverCarRegistrationNumber?: string
  driverCarRegNumTemp?: boolean
  driverCarBrand?: string
  driverCarModel?: string
  driverCarColor?: string
  horsePower?: number
  gearType?: string
  carType?: string
  driverCarMilage?: number
  driverCarRegDate?: string
  fuelType?: string
  driverCarYear?: number
  driverCarNotes?: string
  driverCarStatus?: string
  driverID?: string
  createdAt?: string
  updatedAt?: string
  orgID?: string
}

export interface VehicleListByCustomer extends CursorPagination {
  cars: Vehicle[]
}

export interface VehicleListParams extends CursorPaginationParams {
  orgID: string
}

export interface VehicleCustomerList {
  driverCar?: Vehicle
  driver?: Customer
}

export interface VehicleList extends CursorPagination {
  cars: VehicleCustomerList[]
}

export interface VehicleByCustomerID {
  driverCars?: Vehicle[]
}

export enum VehicleStatus {
  active = 'Active',
  inactive = 'Inactive',
  blacklisted = 'Blacklisted',
}

export type TypeVehicleStatus = 'Active' | 'Inactive' | 'Blacklisted'
